export default {
    // "home": {
    //     "title": "Administração Geral"
    // },
    "modules": {
        "titles": "Módulos",
        "title": "Módulo",
        "list": {
            "order": "@:modules.model.order",
            "name": "@:modules.model.name",
            "guest": "@:modules.model.guest",
            "status": "@:modules.model.status",
            "backoffice": "Gestão",
        },
        "model": {
            "code": "Código",
            "name": "Nome",
            "description": "Descrição",
            "keywords": "Palavras-Chave",
            "order": "Ordem",
            "home": "Página Inicial",
            "backoffice": "Módulo de Gestão",
            "guest": "Acesso",
            "status": "Ativo",
            "url": "Url",
            "icon": "Icon",
            "image": "Imagem",
            "theme_color": "Côr do Tema",
        },
        "help": {
            "name": "Nome do Módulo.",
            "code": "Preencher caso corresponda a um módulo da plataforma, caso contrário, deve definir o campo URL. Apenas são permitidos: caracteres minúsculos não especiais, números, '-' e '_'",
            "order": "Ordem que o módulo aparece no dashboard.",
            "home": "Este módulo aparece na listagem dos módulos na página inicial.",
            "backoffice": "Corresponde a um módulo de gestão.",
            "guest": "Tipo de acesso ao módulo.",
            "icon": "Icon do módulo a apresentar na listagem dos módulos.",
            "theme_color": "Indica a côr para os browsers utilizarem para personalizar a exibição da página ou da interface do utilizador.",
            "url": "Definir o endereço HTTP para um link externo. Se este campo for definido, o campo Código deve estar vazio.",
            "description": "A descrição corresponde ao título SEO e, é ele que vai ser lido pelo Google (na hora que este examina todos os sites da internet) e exibido na página de resultados. Respeitar a quantidade mínima (35) e máxima (65) de caracteres, contando espaços e símbolos, no entanto, o tamanho do título SEO para mobile é de cerca de 55 caracteres. Como queremos garantir que tanto o utilizador no desktop quanto em dispositivos móveis tenham acesso integral ao seu conteúdo, melhor ficar no máximo com 55 caracteres.",
            "keywords": "Escolha a palavra-chave certa. As palavras-chave ou keywords são elementos fundamentais de SEO. São os termos utilizados pelos utilizadores nas pesquisas – o que eles digitam ou comandam por voz ao Google.",
            "public": "Público",
            "private": "Privado",
        },
    },
    "users": {
        "titles": "Utilizadores",
        "title": "Utilizador",
        "msg":{
            "confirm": {
                "delete-item": "Deseja remover o utilizador <u>{name}</u>?",
            }
        },
    },
    "roles": {
        "titles": "Perfis",
        "title": "Perfil"
    },
    "ogc_remote_services": {
        "titles": "Serviços OGC",
        "title": "Serviço OGC",
        "import_resources": "Importar layers"
    }
}

